angular.module('elidb').filter('rsearch', function(ELIService) {
    return function(list,selections, searchText) {
    	if(!list) return null;
    	var trace = angular.trace;

        if(selections) {
            selections = selections.filter(function(a){
                if(parseInt(a) <= 0) return false;
                return true;
            });
        }
        

		var results = [];

		for(var i = 0, count = list.length; i < count; i++) {
			var resource = list[i];
			var tags = resource.tags;
			var satisfied = true;



			if(!satisfiesResourceDependencies(resource,selections)) satisfied = false;
            if(!satisfiesResourceRequirements(resource,selections)) satisfied = false;

//            if(resource.id == 3051) trace(resource,satisfied,satisfiesResourceRequirements(resource,selections),"----");

			for(var j = 0, numtags = selections.length; j < numtags; j++){
				var selection = parseInt(selections[j]);

				if(tags.indexOf(selection) === -1){
					satisfied = false;
					break;
				}
			}

			if(satisfied) results.push(resource);
		}

        if(searchText) {
            searchText = searchText.replace(/[^a-z0-9 ]/gim,"").toLowerCase();
            results = results.filter(function(resource) {
                var name = resource.name.replace(/[^a-z0-9 ]/gim,"").toLowerCase();
                return name.match(searchText);
            });
        }

		results.sort(function(a,b){
           // if(a.statewide === "true" && b.statewide !== "true") return -1;
           // if(a.statewide !== "true" && b.statewide === "true") return 1;
			if(a.distance > b.distance) return 1;
			if(a.distance < b.distance) return -1;
			return 0;
		});

		return results;
    };

    function satisfiesResourceDependencies(resource,selections) {
    	var dependencies = ELIService.resourceDependencies[resource.id];
    	if(!dependencies) return true;
    	selections = selections.map(function(e){return parseInt(e);});

    	var depSatisfied = null;
    	for(var i = 0, count = dependencies.length; i < count; i++) {
    		var dependency = dependencies[i];
    		var triggered = resourceTriggerSelected(selections,dependency.triggers);
    		var satisfied = resourceSatisfiesRequirements(selections,dependency.requirements);
    		
    		if(triggered && satisfied) {
    			return true;
    		} else if(triggered) {
    			depSatisfied = false;
    		}
    	}
    	//if(depSatisfied === false) console.log("we have a filtered resource",resource,selections,dependencies,"-------");
    	if(depSatisfied === false) return false;
    	return true;
    }

    function satisfiesResourceRequirements(resource,selections) {
        var requirements = ELIService.resourceRequirements;
        var tags = resource.tags;
        var test = false;
        var i,count,requirement;
        selections = selections.map(function(e){return parseInt(e);});

        if(!selections.length) return true;

        for(i = 0, count = requirements.length; i < count; i++) {
            requirement = requirements[i];
            if(tags.indexOf(requirement) === -1) continue;
            test = true;
            break;
        }

        if(!test) return true;

        var satisfied = false;

        for(i = 0, count = requirements.length; i < count; i++) {
            requirement = requirements[i];
            if(tags.indexOf(requirement) === -1) continue;
            if(selections.indexOf(requirement) === -1) continue;
            satisfied = true;
            break;
        }

        return satisfied;

    }

    function resourceTriggerSelected(selections,triggers) {
    	for(var i = 0, count = selections.length; i < count; i ++) {
    		if(triggers.indexOf(selections[i]) !== -1) return true;
    	}
    	return false;
    }

    function resourceSatisfiesRequirements(selections,requirements) {
    	for(var i = 0, count = requirements.length; i < count; i++) {
    		if(selections.indexOf(requirements[i]) !== -1) return true;
    	}
    	return false;
    }
});